export default __webpack_public_path__ + "static/media/team-juan.68c50ae4.webp";